import {fun_Download, fun_PostAction} from "@/api/index";
import {fun_DownloadFile} from "@/utils/validate";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 查询表单字段
      form: {
        prjName: null, // 项目名称
        regulators: null, // 备案部门
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "项目名称：",
          value: "prjName",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "备案部门：",
          value: "regulators",
          placeholder: "请选择",
          disabled: false,
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201510311952460006"
          }
        },
      ],
      // 表头按钮组
      btnList: [
        {
          name: "申请解锁",
          type: "success",
          icon: "document-add"
        },
        {
          name: "申请变更",
          type: "success",
          icon: "document-add"
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "prjName",
          width: "380",
          isShow: true,
          fixed: true,
        },
        {
          label: "状态",
          prop: "state",
          fixed: true,
          width: "120"
        },
        {
          label: "项目负责人（总监）",
          prop: "projectManagerName",
          fixed: true,
          width: "170"
        },
        {
          label: "建设单位",
          prop: "buildCorp",
          width: "280"
        },
        {
          label: "联系人",
          prop: "linkMan",
          width: "150"
        },
        {
          label: "联系方式",
          prop: "linkTel",
          width: "150"
        },
        {
          label: "备案部门",
          prop: "regulatorsName",
          width: "300"
        },
        {
          label: "备案项目类别",
          prop: "tenderClassName",
          width: "150"
        },
        {
          label: "备案项目内容",
          prop: "tenderContentName",
          width: "150"
        },
      ],
      // 表格数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 勾选的数组
      multipleSelection: [],
      userFlag: sessionStorage.getItem("userFlag"), // 用户标识
      userType: sessionStorage.getItem("loginType"), // 用户类型
    };
  },
  // 注册组件
  components: {
  },

  // 模板编译完成
  mounted() {
    // 获取用户信息
    this.fun_GetUser();
    // 获取一览
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取用户信息
     * @returns {Promise<void>}
     */
    async fun_GetUser() {
      // 如果用户标识是工作人员或者监管人员
      if ("工作人员" == this.userFlag || "监管人员" == this.userFlag) {
        // 清空表头
        this.btnList = [
          {
            name: "台帐导出",
            type: "success",
          }
        ];
      }
    },
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/contractProjectManager/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      this.form[i] = e;
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      switch (e) {
        case "申请解锁":
          // 申请解锁
          this.fun_UpdateRecord("10");
          break;
        case "申请变更":
          // 申请解锁
          this.fun_UpdateRecord("11");
          break;
        case "台帐导出":
          // 台帐导出
          this.fun_ImportExcel();
          break;
        default:
          "";
      }
    },
    /**
     * 申请解锁/变更的方法
     * @author shuhua
     */
    fun_UpdateRecord(type) {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 如果勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return;
        } else {
          // 状态
          let state = this.multipleSelection[0].state;
          // 如果解锁中或者变更中或者解锁通过
          if (state == "解锁中" || state == "变更中" || state == "解锁通过") {
            this.$alert("存在已提交或审核通过的项目，不能申请解锁/变更！", "warning");
            return;
          }
          // 如果是申请解锁
          if(type == "10") {
            // 招标内容
            let tenderContentNum = this.multipleSelection[0].tenderContentNum;
            // 如果招标内容不为施工
            if (tenderContentNum != '201603181125070012' && tenderContentNum != '201603181125220013' && tenderContentNum != '201603181125350014' &&
                tenderContentNum != '201603181128050019' && tenderContentNum != '201603181126230015' && tenderContentNum != '201603181128490021') {
              this.$alert("该项目无需解锁！", "warning");
              return;
            }
          }
          // 跳转详情页面
          this.$router.push({
            path: "/contractProjectManagerDetail",
            query: {
              controllerFlg: "update",
              id: this.multipleSelection[0].id,
              type: type
            }
          });
        }
      } else {
        // 未勾选，则提示
        this.$alert("请至少选中一行数据！", "warning");
        return;
      }
    },
    /**
     * 查看详情
     * @author shuhua
     */
    fun_LookDetails(e) {
      // 请求参数
      let obj = {
        controllerFlg: "detail",
        id: e.val.id,
        type: e.val.type,
      }
      // 跳转详情页面
      this.$router.push({
        path: "/contractProjectManagerDetail",
        query: obj,
      });
    },
    /**
     * 台帐导出的方法
     * @author shuhua
     */
    fun_ImportExcel() {
      try {
        // 请求，获取结果集
        fun_Download("/contractProjectManager/export", {
          ...this.form,
        }).then(res => {
          // 获取到Content-Disposition;filename
          let fileNames = res.headers["content-disposition"];
          if (fileNames) {
            let regFileNames = fileNames.match(/=(.*)$/)[1];
            // 调用下载文件公共方法
            fun_DownloadFile(res, decodeURIComponent(regFileNames));
            // 关闭加载
            this.loading = false;
          } else {
            // 关闭加载
            this.loading = false;
            // 提示请求失败消息
            this.$message.error("文件不存在！");
          }
        });
      } catch {
      }
    },
  }
};
